export default __webpack_public_path__ + "static/media/contact_bg_jingzheng.391d0db3.jpg";